'use strict';

module.exports = function random(length) {
  var randomLength = length || 1;

  var randomCollection = this.slice().shuffle().take(randomLength);

  if (randomLength === 1) {
    return randomCollection.first();
  }

  return randomCollection;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/random.js
// module id = 282
// module chunks = 0